import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { addAdmin, adminSelector, setError } from "slices/adminSlice";
import ErrorMessage from "components/common/ErrorMessage";
import { SubmitButton } from "components/common/buttons/SubmitButton";

const AddAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(adminSelector);
  const { handleSubmit, control, watch, formState: { errors } } = useForm({
    defaultValues: { name: "", email: "", password: "", password_confirmation: "" },
  });

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message || "Admin created successfully.", { className: "successToast" });
      dispatch(setError({}));
      navigate("/admins");
    } else {
      toast.error(message || "Could not create admin.", { className: "errorToast" });
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}));
    const fd = new FormData();
    fd.append("name", data.name);
    fd.append("email", data.email);
    fd.append("password", data.password);
    fd.append("password_confirmation", data.password_confirmation);
    dispatch(addAdmin(fd, submitCallback));
  };

  return (
    <div className="content">
      <div className="row_main_head">
        <button className="main_heading back_button" onClick={() => navigate(-1)}>Back</button>
        <h2 className="main_heading">Create Admin</h2>
      </div>

      <div className="card_table p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row-primary">
            <h2>Name *</h2>
            <div className="w-100">
              <Controller
                name="name"
                control={control}
                rules={{ required: "Please enter a name" }}
                render={({ field }) => (
                  <input className="input-in type_inp" type="text" placeholder="Name" {...field} />
                )}
              />
              {errors?.name?.message && <ErrorMessage text={errors.name.message} />}
              {error?.errors?.name?.map((e, i) => <ErrorMessage key={i} text={e} />)}
            </div>
          </div>

          <div className="row-primary">
            <h2>Email *</h2>
            <div className="w-100">
              <Controller
                name="email"
                control={control}
                rules={{
                  required: "Please enter an email",
                  pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Enter a valid email" },
                }}
                render={({ field }) => (
                  <input className="input-in type_inp" type="email" placeholder="Email" {...field} />
                )}
              />
              {errors?.email?.message && <ErrorMessage text={errors.email.message} />}
              {error?.errors?.email?.map((e, i) => <ErrorMessage key={i} text={e} />)}
            </div>
          </div>

          <div className="row-primary">
            <h2>Password *</h2>
            <div className="w-100">
              <Controller
                name="password"
                control={control}
                rules={{ required: "Please enter a password", minLength: { value: 8, message: "Minimum 8 characters" } }}
                render={({ field }) => (
                  <input className="input-in type_inp" type="password" placeholder="Password" {...field} />
                )}
              />
              {errors?.password?.message && <ErrorMessage text={errors.password.message} />}
              {error?.errors?.password?.map((e, i) => <ErrorMessage key={i} text={e} />)}
            </div>
          </div>

          <div className="row-primary">
            <h2>Confirm Password *</h2>
            <div className="w-100">
              <Controller
                name="password_confirmation"
                control={control}
                rules={{
                  required: "Please confirm the password",
                  validate: (val) => val === watch("password") || "Passwords do not match",
                }}
                render={({ field }) => (
                  <input className="input-in type_inp" type="password" placeholder="Confirm Password" {...field} />
                )}
              />
              {errors?.password_confirmation?.message && <ErrorMessage text={errors.password_confirmation.message} />}
            </div>
          </div>

          <div className="Form-footer">
            <button type="button" className="Cancle_button" onClick={() => navigate("/admins")}>Cancel</button>
            <SubmitButton loader={loader} btnText="Create" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdmin;
